import type { ArtifactPlan, BuildIntake, FileTreeNode } from "../../types";
import { uid } from "../storage";

function defaultTree(stack: string): FileTreeNode[] {
  const base: FileTreeNode[] = [
    { path: "package.json", kind: "file", note: "scripts: dev, build, typecheck" },
    { path: "src/", kind: "dir" },
    { path: "src/main.tsx", kind: "file" },
    { path: "src/App.tsx", kind: "file" },
    { path: "src/lib/engine/", kind: "dir", note: "deterministic local logic" },
    { path: "src/components/", kind: "dir" },
    { path: "public/", kind: "dir" },
  ];
  if (stack.includes("cloudflare") || stack.includes("worker")) {
    base.push({ path: "wrangler.toml", kind: "file", note: "CF Pages/Workers deploy" });
  }
  if (stack.includes("next")) {
    return [
      { path: "package.json", kind: "file" },
      { path: "app/page.tsx", kind: "file" },
      { path: "app/layout.tsx", kind: "file" },
      { path: "src/lib/", kind: "dir" },
    ];
  }
  return base;
}

export function planArtifacts(intake?: BuildIntake): ArtifactPlan {
  const stack = intake?.stackPreference ?? "react-vite";
  const name = intake?.projectName ?? "sovereign-project";
  const fileTree = defaultTree(stack);

  const requiredFiles = fileTree.filter((n) => n.kind === "file").map((n) => n.path);
  const missingFiles = requiredFiles.filter((f) => !["package.json"].includes(f));

  const commands = [
    "npm install",
    "npm run typecheck",
    "npm run build",
    "npm run preview",
  ];

  if (stack === "cloudflare-workers") {
    commands.push("npx wrangler pages deploy dist");
  }

  const verification = [
    "All product surfaces render without network",
    "Export center downloads MD and JSON",
    "No API key fields on public surfaces",
    "Sovereign runtime shows no-paywall locked ON",
    "Mobile layout usable at 375px width",
  ];

  let deployTarget = "Static host / Cloudflare Pages → bob.arkmpyre.com";
  if (stack === "cloudflare-workers") deployTarget = "Cloudflare Workers/Pages";
  if (stack === "nextjs") deployTarget = "Next static export or CF adapter";

  return {
    id: uid("plan"),
    intakeId: intake?.id,
    fileTree,
    requiredFiles,
    missingFiles,
    commands,
    verification,
    deployTarget: `${deployTarget} (${name})`,
    createdAt: new Date().toISOString(),
  };
}
